<div [ngStyle]="environment.theme.background" class="min-h-screen bg-[var(--primary-dark)] flex items-center justify-center p-3 md:p-4">
  <div class="w-full max-w-md bg-white rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.15)] overflow-hidden">

    <div class="flex justify-center py-8 bg-[var(--background-registration)]">
      <img class="max-h-28 object-contain" [ngStyle]="environment?.theme?.logoStyling" [src]="environment?.theme?.logo" alt="Logo">
    </div>

    <div class="px-5 py-6 md:px-8 md:py-8 text-center">
      <div class="flex justify-center mb-4">
        <span class="material-icons text-[48px] text-[var(--notification-success)]" data-cy="activation-success-icon">check_circle_outline</span>
      </div>
      <p class="text-[var(--base-text-alt-dark)] text-[15px] font-semibold mb-3" data-cy="activation-header">Your account has been activated.</p>
      <p class="text-[var(--base-text-alt-dark)] text-[13px] leading-relaxed mb-6" data-cy="activation-message">Thank you for activating your account, please check your email inbox for details to login.</p>
      <a [href]="window.location.origin" target="_blank" class="flex items-center justify-center gap-2 text-[var(--primary-dark)] text-[13px] font-semibold no-underline" data-cy="back-to-login-link">
        <span class="material-icons text-[18px]">keyboard_backspace</span>
        <span data-cy="back-to-login-text">Back to Login</span>
      </a>
    </div>
  </div>
</div>
